/* eslint-disable jsx-a11y/alt-text */
'use client'
import { BulletListProps } from '@/components/molecules/BulletList'
import { NormalizedSection, RemappedCMSimageType, TitleProps } from '@/types'
import { Image, List, Section, Title } from '@dynamo-caffeina-dev/airc-ui-kit'
import NextImage from 'next/image'
import { useMemo } from 'react'

export interface RecipeIngredientsProps extends NormalizedSection {
  modelledContent: {
    title: TitleProps
    bulletList: BulletListProps['content']
    image: RemappedCMSimageType
  }
}

function RecipeIngredients({ modelledContent }: RecipeIngredientsProps) {
  const { title, bulletList, image } = modelledContent
  const titleLabel = title?.content
  const { fit, imageProps } = image

  const items = useMemo(
    () =>
      bulletList.map((content) => ({
        content,
      })),
    [bulletList]
  )

  return (
    <Section className='section-recipe-ingredients'>
      <div className='section-recipe-ingredients__content-wrapper'>
        {imageProps.src ? (
          <Image
            fit={fit}
            className='section-recipe-ingredients__content-wrapper__image'
            as={NextImage}
            imageProps={{
              ...imageProps,
              // If not present (which it will not be,
              // since the CMS is not returning them),
              // it'll take the default value.
              // TODO find out why these props were expected here,
              // @ts-ignore
              width: imageProps.width || 400,
              // @ts-ignore
              height: imageProps.height || 400,
            }}
          />
        ) : null}
        <div className='section-recipe-ingredients__content-wrapper__text-wrapper'>
          {title && titleLabel ? (
            <Title
              className={
                'section-recipe-ingredients__content-wrapper__text-wrapper__title'
              }
              {...title}
              as={'h2'}
              dangerouslySetInnerHTML={{ __html: titleLabel }}
            />
          ) : null}
          {bulletList && bulletList.length > 0 ? <List {...{ items }} /> : null}
        </div>
      </div>
    </Section>
  )
}

export default RecipeIngredients
